"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavItems = void 0;
var ioc_1 = require("../ioc");
var AuthControlledNavigation_1 = require("../navigation/AuthControlledNavigation");
var NavItem_1 = require("../navigation/NavItem");
var useNavItems = function (configuration) {
    var allNavItems = ioc_1.getCoreContainer().getAll(ioc_1.CORE_TYPES.NavItem);
    var allowedNavItems = allNavItems
        .filter(AuthControlledNavigation_1.userCanAccessRoute(configuration.userIsAuthenticated, configuration.userPermissions))
        .sort(NavItem_1.compareNavItems)
        .map(function (i) {
        return __assign(__assign({}, i), { subNavItems: i.subNavItems && i.subNavItems.length > 0
                ? i.subNavItems.filter(AuthControlledNavigation_1.userCanAccessRoute(configuration.userIsAuthenticated, configuration.userPermissions))
                : [] });
    });
    return { allowedNavItems: allowedNavItems, allNavItems: allNavItems };
};
exports.useNavItems = useNavItems;
//# sourceMappingURL=useNavItems.js.map